<template>
  <address-form
    v-if="editing"
    :address="utdAddress"
    @edited="edited"
    @cancelled="editing = false"
  />

  <div
    v-else
    class="address-row address-list__row"
    :class="{ deleting: deleting }"
    @click="goToAddress"
  >
    <div>
      <div
        ref="alias"
        :class="{ 'address-row-alias--add-alias': utdAddress.name === '' }"
        class="address-row-alias"
        @click.stop="editing = true"
      >
        <span v-if="utdAddress.name !== ''" class="address-row-alias__name">
          {{ utdAddress.name }}
        </span>

        <span v-else class="address-row-alias__add" @click="editing = true">
          <span>{{ trans('addresses.body.table.actions.add_address') }}</span>
        </span>

        <div class="address-row-alias__address">
          {{ addressToString(utdAddress) }}
        </div>
      </div>
    </div>

    <div v-if="deleting" class="address-row__deleting-desktop row-deleting-desktop">
      <div class="row-deleting-desktop__btns">
        <button
          class="row-deleting-desktop__confirm btn btn--secondary red btn--with-icon"
          :class="{ disabled: !canDelete, 'loading-btn': saveLoading }"
          @click.stop="onConfirmDelete"
        >
          <span>{{ trans('addresses.body.table.actions.delete') }}</span>
        </button>
        <button
          class="row-deleting-desktop__cancel desktop-cancel btn btn--secondary"
          :class="{ disabled: !canDelete }"
          @click.stop="deleting = false"
        />
      </div>
    </div>

    <div class="address-row__contacts row-contacts">
      <address-contacts
        :address="address"
        show-link
      />
    </div>

    <div class="address-row__nb-offers">
      <a v-if="address.nbOffers !== null && address.nbOffers !== undefined" :href="offersLink">
        {{
          address.nbOffers !== null && address.nbOffers !== undefined
            ? transchoice('addresses.body.table.offer', { count: address.nbOffers })
            : ''
        }}
      </a>
    </div>

    <div class="address-row__open row-open" />

    <div class="address-row__actions row-actions" @click.prevent.stop>
      <a class="row-actions__update btn btn--secondary" :href="addressDetailsLink" @click.stop="goToAddress">
        <span>{{ trans('addresses.body.table.actions.show') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import AddressContacts from '@components-molecules/AddressContacts.vue';
import { addressToString } from '@elements/address-utils';
import { translationMixin } from '@elements/translation';
import { googlePlacesApiUtilsMixin } from '@molecules/google-places-api-utils';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';
import { requestsMixin } from '@tools/requests-mixin';
import { URL_ADDRESS_DETAILS, URL_USER_OFFERS, URL_XHR_ADDRESS_ID } from '@tools/routes/routes';
import { storeToRefs } from 'pinia';
import AddressForm from './AddressForm.vue';

export default {
  components: { AddressContacts, AddressForm },
  mixins: [ translationMixin, googlePlacesApiUtilsMixin, requestsMixin ],
  props: {
    address: {
      type: Object,
      default: () => {
      },
    },
  },
  setup() {
    const { isTabletLarge, isDesktop } = storeToRefs(useScreensizeStore());

    return {
      isTabletLarge,
      isDesktop,
    };
  },
  data() {
    return {
      utdAddress: { ...this.address },
      addressElement: null,
      editing: false,
      deleting: false,
      saveLoading: false,
    };
  },
  computed: {
    addressDetailsLink() {
      return `${URL_ADDRESS_DETAILS.replace('{id}', this.address.id)}`;
    },
    offersLink() {
      return `${URL_USER_OFFERS}?addresses=${this.utdAddress.id}`;
    },
    canDelete() {
      return this.utdAddress.nbOffers === 0 && !this.saveLoading;
    },
    desktopMode() {
      return this.isTabletLarge || this.isDesktop;
    },
  },
  watch: {
    address(address) {
      this.editing = false;
      this.deleting = false;
      this.utdAddress = { ...address };
    },
  },
  methods: {
    addressToString,
    goToAddress() {
      if (!this.desktopMode) {
        return false;
      }
      window.location.href = this.addressDetailsLink;
      return true;
    },
    edited() {
      this.$emit('edited');
    },
    onDelete() {
      if (this.canDelete) {
        this.deleting = true;
      }
    },
    async onConfirmDelete() {
      if (this.saveLoading) {
        return;
      }

      this.saveLoading = true;

      try {
        await this.delete(URL_XHR_ADDRESS_ID.replace('{id}', this.utdAddress.id), { emulateJSON: false });
        flashBagSuccess(this.trans('addresses.body.table.form.message.remove_success'));
        this.$emit('deleted', this.utdAddress.id);
      } catch {
        flashBagError();
        this.saveLoading = false;
      }
    },
  },
};
</script>
